// Miky Motorsport - cista aritmetika loftovane karoserie (positions + indices).
// Bez THREE - vraci ciste pole cisel, takze je testovatelne v Node.
// render/scene.js z techto poli postavi BufferGeometry (computeVertexNormals).
// Chovani vizualu zustava identicke.

// Lofted uzavreny hull z podelnych "stations" (cross-section ringy spojene do plochy).
// hw = polosirka, hl = polodelka. station: { f:0..1 (predek->zadek), w:frakce sirky, yl, yh, box }.
// Vraci { positions:number[], indices:number[] } - hotova data pro BufferGeometry.
export function loftGeometry(stations, hw, hl) {
  const N = 16; // bodu na ring
  const positions = [];
  const indices = [];
  const ringZ = [];
  for (const s of stations) {
    const z = (0.5 - s.f) * 2 * hl;
    ringZ.push(z);
    const midY = (s.yl + s.yh) / 2, hh = (s.yh - s.yl) / 2;
    // e = exponent (nizsi = hranatejsi/plnejsi prurez). box vyssi -> hranatejsi.
    const e = 1 / (s.box || 2.6);
    for (let k = 0; k < N; k++) {
      const t = (k / N) * Math.PI * 2;
      const c = Math.cos(t), sn = Math.sin(t);
      // svisla souradnice: ploche siroke dno + zaobleny vrch (auto-prurez, ne elipsa)
      const y = midY + hh * Math.sign(sn) * Math.pow(Math.abs(sn), e);
      const hf = (y - s.yl) / Math.max(0.001, (s.yh - s.yl)); // 0 dole .. 1 nahore
      const taper = 1 - 0.18 * hf; // tumblehome: nahore uzsi (sklon boku)
      const x = hw * s.w * taper * Math.sign(c) * Math.pow(Math.abs(c), e);
      positions.push(x, y, z);
    }
  }
  const R = stations.length;
  // bocni faces (winding tak, aby normaly mirily VEN z karoserie)
  for (let i = 0; i < R - 1; i++) {
    for (let k = 0; k < N; k++) {
      const a = i * N + k, b = i * N + (k + 1) % N, c = (i + 1) * N + k, d = (i + 1) * N + (k + 1) % N;
      indices.push(a, c, b, b, c, d);
    }
  }
  // cap predek (fan na stredovy vrchol)
  const fc = positions.length / 3;
  positions.push(0, (stations[0].yl + stations[0].yh) / 2, ringZ[0]);
  for (let k = 0; k < N; k++) indices.push(fc, k, (k + 1) % N);
  // cap zadek
  const rc = positions.length / 3;
  const last = R - 1;
  positions.push(0, (stations[last].yl + stations[last].yh) / 2, ringZ[last]);
  for (let k = 0; k < N; k++) indices.push(rc, last * N + (k + 1) % N, last * N + k);

  return { positions, indices };
}
